// extracted by mini-css-extract-plugin
export default {"switch_checkbox":"Toggle_switch_checkbox__CTlaB","switch_label":"Toggle_switch_label__MO7iQ","switch_button":"Toggle_switch_button__gshOJ"};